import createIcon from '../../createIcon';

/**
 * @component @name KeyboardArrowDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy40MSA4LjI5NDkyTDEyIDEyLjg3NDlMMTYuNTkgOC4yOTQ5MkwxOCA5LjcwNDkyTDEyIDE1LjcwNDlMNiA5LjcwNDkyTDcuNDEgOC4yOTQ5MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardArrowDown = createIcon('KeyboardArrowDown', [
  [
    'path',
    {
      d: 'M7.41 8.29492L12 12.8749L16.59 8.29492L18 9.70492L12 15.7049L6 9.70492L7.41 8.29492Z',
      key: '1q2iou',
    },
  ],
]);

export default KeyboardArrowDown;
